import Vue from 'vue';
import VueRouter from 'vue-router';
import consts from '@/static/js/consts';

import Default from '@/views';
import Home from '@/views/home';
import Artistas from '@/views/artistas/index';
import Calendario from '@/views/calendario/index';
import Leilao from '@/views/leilao/index';
import Leiloes from '@/views/leilao/lista/index';
import LeilaoLote from '@/views/leilao/lote/index';
import Eventos from '@/views/eventos/index';

import RouterService from '@/services/RouterService';

Vue.use(VueRouter);

// const protectRoute = {
//   protected: true,
// };

const routes = [
  {
    path: '/',
    name: consts.ROUTES.AUTH.NAME,
    beforeEnter: RouterService.autoLogin,
    component: Default,
    meta: {
      protected: false,
      darkMode: false,
    },
    children: [
      {
        alias: '/',
        path: '/',
        name: consts.ROUTES.HOME.NAME,
        component: Home,
        meta: {
          darkMode: false,
        },
      },
      {
        alias: 'calendario',
        path: 'calendario',
        name: consts.ROUTES.CALENDARIO.NAME,
        component: Calendario,
        meta: {
          darkMode: false,
        },
      },
      {
        alias: 'eventos',
        path: 'eventos',
        name: consts.ROUTES.EVENTOS.NAME,
        component: Eventos,
        meta: {
          darkMode: false,
        },
      },
      {
        alias: 'artistas',
        path: 'artistas',
        name: consts.ROUTES.ARTISTAS.NAME,
        component: Artistas,
        meta: {
          darkMode: false,
        },
      },
      {
        alias: 'leiloes',
        path: 'leiloes',
        name: consts.ROUTES.LEILOES.NAME,
        component: Leiloes,
        meta: {
          darkMode: false,
        },
      },
      {
        alias: 'leilao/:leilao',
        path: 'leilao/:leilao',
        name: consts.ROUTES.LEILAO.NAME,
        component: Leilao,
        meta: {
          darkMode: false,
        },
      },
      {
        alias: 'leilao/:leilao/lote/:lote',
        path: 'leilao/:leilao/lote/:lote',
        name: consts.ROUTES.LEILAO_LOTE.NAME,
        component: LeilaoLote,
        meta: {
          darkMode: false,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } if (to.hash) {
      return {
        selector: to.hash,
      };
    }
    return { x: 0, y: 0 };
  },
});

window.addEventListener('change-route', (routeName) => {
  router.push({ name: routeName.detail });
}, false);

export default router;
